import apiHub from "../services/apiHub";
import getHeadersHub from "../utils/returnHeadersHub";

export default class HotelRepository {
  searchAutoComplete = (name) => {
    const header = getHeadersHub();

    return apiHub.post(
      `/api/services/hotel/auto-complete/`,
      {
        filter: {
          name: name,
        },
      },
      header,
    );
  };

  searchByDestination = (data) => {
    const header = getHeadersHub();

    return apiHub.post(
      `/api/services/hotel/search/`,
      {
        filter: {
          start: data.start,
          end: data.end,
          destination: data.destination,
          occupancy: data.occupancy,
        },
      },
      header,
    );
  };

  searchByHotel = (data) => {
    const header = getHeadersHub();

    return apiHub.post(
      `/api/services/hotel/search/`,
      {
        filter: {
          start: data.start,
          end: data.end,
          hotel: data.hotel.id,
          occupancy: data.occupancy,
        },
      },
      header,
    );
  };

  checkRate = async (data) => {
    const header = getHeadersHub();

    return apiHub.post(
      `/api/services/hotel/get/`,
      {
        filter: data,
      },
      header,
    );
  };

  booking = async (data) => {
    const header = getHeadersHub();

    return apiHub.post(`/api/services/hotel/booking/`, data, header);
  };
}
